// extracted by mini-css-extract-plugin
module.exports = {"activism-page-type":"activism-page-type__aLpoy","accessibility-skip":"accessibility-skip__S6ek5","accessibility-skip__showing":"accessibility-skip__showing__kI8yB"};